import { render, staticRenderFns } from "./AbkSectionHeader.vue?vue&type=template&id=ace87a6c&scoped=true&"
import script from "./AbkSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AbkSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AbkSectionHeader.vue?vue&type=style&index=0&id=ace87a6c&scoped=true&lang=scss&"
import style1 from "./AbkSectionHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace87a6c",
  null
  
)

export default component.exports